import React from "react";
import classes from "./Navbar.module.scss";
import { Modal } from "react-bootstrap";
import Button from "../UI/Button";
import { useTranslation } from "react-i18next";

const BlockedModal = ({
  onCloseBlock,
  blockedData,
}) => {
  const {t} = useTranslation();
  return (
    <Modal
      show={blockedData.isBlocked}
      dialogClassName={classes["blocked-modal"]}
      size="lg"
    >
      <p className="text-center"><h3>{t("Services are currently disabled.")}</h3></p>
      <p className="text-center">{blockedData.desc}</p>
      <div className="text-center">{t("Please contact us at")}: <a href="mailto:support@dddinvoices.com">support@dddinvoices.com</a></div>
      <div className="text-center">
        <Button
          className="px-5 py-1 mt-3"
          style={{ width: "fit-content" }}
          onClick={onCloseBlock}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default BlockedModal;
